import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9ef5fa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Questões", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemDeQuestaoOpcao = _resolveComponent("ItemDeQuestaoOpcao")!
  const _component_ItemDeQuestaoSelecao = _resolveComponent("ItemDeQuestaoSelecao")!
  const _component_AdicionarQuestaoOpcao = _resolveComponent("AdicionarQuestaoOpcao")!
  const _component_AdicionarQuestaoSelecao = _resolveComponent("AdicionarQuestaoSelecao")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_TransitionGroup, { name: "questoes" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itensOrdenados, (questao, indice) => {
          return (_openBlock(), _createElementBlock("div", {
            key: questao.getId().toString()
          }, [
            (questao.tipo === 'opcao')
              ? (_openBlock(), _createBlock(_component_ItemDeQuestaoOpcao, {
                  key: 0,
                  questao: (questao as QuestaoOpcaoEditavel),
                  ehPrimeiro: indice === 0,
                  ehUltimo: indice === _ctx.itensOrdenados.length - 1,
                  indice: indice,
                  onEditar: _ctx.editar,
                  onExcluir: _ctx.excluir,
                  onDescer: _ctx.descer,
                  onSubir: _ctx.subir
                }, null, 8, ["questao", "ehPrimeiro", "ehUltimo", "indice", "onEditar", "onExcluir", "onDescer", "onSubir"]))
              : _createCommentVNode("", true),
            (questao.tipo === 'selecao')
              ? (_openBlock(), _createBlock(_component_ItemDeQuestaoSelecao, {
                  key: 1,
                  questao: (questao as QuestaoSelecaoEditavel),
                  ehPrimeiro: indice === 0,
                  ehUltimo: indice === _ctx.itensOrdenados.length - 1,
                  onEditar: _ctx.editar,
                  onExcluir: _ctx.excluir,
                  onDescer: _ctx.descer,
                  onSubir: _ctx.subir
                }, null, 8, ["questao", "ehPrimeiro", "ehUltimo", "onEditar", "onExcluir", "onDescer", "onSubir"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_AdicionarQuestaoOpcao, {
      indice: _ctx.itensOrdenados.length,
      onAdicionarItem: _ctx.adicionarItem
    }, null, 8, ["indice", "onAdicionarItem"]),
    _createVNode(_component_AdicionarQuestaoSelecao, {
      indice: _ctx.itensOrdenados.length,
      onAdicionarItem: _ctx.adicionarItem
    }, null, 8, ["indice", "onAdicionarItem"])
  ], 64))
}